'use client';

import { ScreenContent, ScreenTabBar } from '@/screen';
import { ErrorMessage } from '@/components/ErrorMessage';

// WHY: без своей границы ошибка страницы новостей уходит в global-error, а он заменяет весь корень вместе с шапкой; граница
// под layout новостей оставляет экран ошибки в его каркасе
export default function NewsError({ retry }: { retry: () => void }) {
  return (
    <>
      <ScreenTabBar />
      <ScreenContent className="flex items-center justify-center p-4">
        <ErrorMessage onRetry={retry} />
      </ScreenContent>
    </>
  );
}
